import React, { useState } from 'react';
import { ButtonBase, Checkbox, Grid, IconButton, Typography, useMediaQuery } from '@mui/material';
import { Box, Stack } from '@mui/system';
import moment from 'moment';

function convertToAMPM(hour24: any) {
  if (hour24 < 0 || hour24 > 23) {
    return 'Invalid';
  }

  if (hour24 === 0) {
    return '12 am';
  } else if (hour24 === 12) {
    return '12 pm';
  } else if (hour24 < 12) {
    return hour24 + ' am';
  } else {
    return hour24 - 12 + ' pm';
  }
}

const IconUp = ({ color = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M9 7.5L6 4.5L3 7.5"
        stroke={color ? '#7f7d7dc2' : '#6366F1'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const IconDown = ({ color = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M3 4.5L6 7.5L9 4.5"
        stroke={color ? '#7f7d7dc2' : '#6366F1'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditEventContent = ({ event, setEditEvent }: any) => {
  const isIpadPortrait = useMediaQuery('(max-width:768px) and (max-height:1024px)');
  const isIpadLandscape = useMediaQuery('(max-width:1024px) and (max-height:768px)');

  const [switchState, setSwitchState] = useState(event.extendedProps.isBlocked);
  const [hoursAvailable, setHoursAvailable] = useState(
    event.extendedProps.hours > 0 ? event.extendedProps.hours : 0
  );
  const [startTime, setStartTime] = useState(event.extendedProps.start);

  const handleChangeStatusOfBlockDay = (e: any, id: any) => {
    setSwitchState(e.target.checked);
    if (!e.target.checked) {
      setHoursAvailable(8);
      return setEditEvent((prevEvents: any) => {
        return prevEvents.map((event: any) => {
          if (event?.extendedProps?.currentDate === id) {
            return {
              ...event,
              isBlocked: false,
              extendedProps: {
                ...event.extendedProps,
                hours: 8,
              },
            };
          }
          return event;
        });
      });
    }

    setEditEvent((prevEvents: any) => {
      return prevEvents.map((event: any) => {
        if (event.extendedProps.currentDate === id) {
          return {
            ...event,
            isBlocked: e.target.checked,
          };
        }
        return event;
      });
    });
  };

  const handleChangeStartDate = (changedValue: number, currentDate: any) => {
    changedValue = (changedValue + 24) % 24;

    setStartTime(changedValue);
    setEditEvent((prevEvents: any) => {
      return prevEvents.map((event: any) => {
        if (event?.extendedProps?.currentDate === currentDate) {
          return {
            ...event,
            extendedProps: {
              ...event.extendedProps,
              start: changedValue,
            },
          };
        }
        return event;
      });
    });
  };

  const handelChangeAvailHours = (changedValue: any, currentDate: any, actionType: string) => {
    setHoursAvailable(changedValue);

    if (actionType === 'INCREASE' && changedValue === 1) {
      setSwitchState(false);
      return setEditEvent((prevEvents: any) => {
        return prevEvents.map((event: any) => {
          if (event?.extendedProps?.currentDate === currentDate) {
            return {
              ...event,
              isBlocked: false,
              extendedProps: {
                ...event.extendedProps,
                hours: changedValue,
              },
            };
          }
          return event;
        });
      });
    }

    if (changedValue !== 0) {
      return setEditEvent((prevEvents: any) => {
        return prevEvents.map((event: any) => {
          if (event?.extendedProps?.currentDate === currentDate) {
            return {
              ...event,
              extendedProps: {
                ...event.extendedProps,
                hours: changedValue,
              },
            };
          }
          return event;
        });
      });
    } else {
      setSwitchState(true);
      return setEditEvent((prevEvents: any) => {
        return prevEvents.map((event: any) => {
          if (event.extendedProps.currentDate === currentDate) {
            return {
              ...event,
              isBlocked: true,
              extendedProps: {
                ...event.extendedProps,
                hours: changedValue,
              },
            };
          }
          return event;
        });
      });
    }
  };

  const maxHoursAvailable = hoursAvailable === 24;
  const disableDecreaseAvail = hoursAvailable === 0;

  const lableStyle = {
    fontSize: '12px',
    fontWeight: 500,
    color: '#6C737F',
    textAlign: 'center',
  };

  const styles = {
    display: 'flex',
    justifyContent: 'space-between',
    border: `1px solid ${switchState ? '#B5BCC4' : 'rgba(99, 102, 241, 0.50)'}`,
    borderRadius: '12px',
    width: '114px',
    height: '50px',
    alignItems: 'center',
  };

  // Inline media query using the style attribute
  const mediaQueryStyles = {
    '@media (max-width: 900px)': {
      width: '95px',
    },
    '@media (max-width: 800px)': {
      width: '85px',
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',

        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack
        textAlign="center"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography sx={{ ...lableStyle, width: '100%', textAlign: 'start', paddingLeft: '5px' }}>
          Hours Available
        </Typography>

        <Box mt={1}>
          <ButtonBase sx={{ ...styles, ...mediaQueryStyles }}>
            <Typography
              variant="caption"
              fontWeight={500}
              sx={{
                color: '#111927',
                width: '100%',
                padding: '0px 15px',
                textAlign: 'start',
                whiteSpace: 'nowrap',
              }}
            >
              {hoursAvailable}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                margin: ' 6px 4px 6px 0px;',
                gap: '3px',
              }}
            >
              <IconButton
                sx={{
                  height: '20px',
                  width: '30px',
                  borderRadius: '0px 12px 0px 0px',
                  background: '#EBEEFE',
                  '&:hover': {
                    background: '#EBEEFE',
                    borderRadius: '0px 12px 0px 0px',
                  },
                  '&.Mui-disabled': {
                    background: '#d3d3d3c2',
                  },
                }}
                disabled={maxHoursAvailable || switchState}
                onClick={() =>
                  handelChangeAvailHours(
                    hoursAvailable + 1,
                    event.extendedProps.currentDate,
                    'INCREASE'
                  )
                }
              >
                <IconUp color={maxHoursAvailable || switchState} />
              </IconButton>

              <IconButton
                sx={{
                  height: '20px',
                  width: '30px',
                  borderRadius: ' 0px 0px 12px 0px;',
                  background: '#EBEEFE',
                  '&:hover': {
                    background: '#EBEEFE',
                    borderRadius: ' 0px 0px 12px 0px;',
                  },
                  '&.Mui-disabled': {
                    background: '#d3d3d3c2',
                  },
                }}
                disabled={disableDecreaseAvail || switchState}
                onClick={() =>
                  handelChangeAvailHours(
                    hoursAvailable - 1,
                    event.extendedProps.currentDate,
                    'DECREASE'
                  )
                }
              >
                <IconDown color={disableDecreaseAvail || switchState} />
              </IconButton>
            </Box>
          </ButtonBase>
        </Box>
        <Typography
          sx={{
            ...lableStyle,
            marginTop: isIpadPortrait || isIpadLandscape ? '100px' : '14px',
            width: '100%',
            textAlign: 'start',
            paddingLeft: '5px',
          }}
        >
          Starting
        </Typography>

        <Box mt={1}>
          <ButtonBase sx={{ ...styles, ...mediaQueryStyles }}>
            <Typography
              variant="caption"
              fontWeight={500}
              sx={{
                color: '#111927',
                width: '100%',
                padding: '0px 6px',
                textAlign: 'start',
                whiteSpace: 'nowrap',
              }}
            >
              {convertToAMPM(startTime)}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                margin: ' 6px 4px 6px 0px;',
                gap: '3px',
              }}
            >
              <IconButton
                sx={{
                  height: '20px',
                  width: '30px',
                  borderRadius: '0px 12px 0px 0px',
                  background: '#EBEEFE',
                  '&:hover': {
                    background: '#EBEEFE',
                    borderRadius: '0px 12px 0px 0px',
                  },
                  '&.Mui-disabled': {
                    background: '#d3d3d3c2',
                  },
                }}
                disabled={switchState}
                onClick={() =>
                  handleChangeStartDate(+startTime + 1, event.extendedProps.currentDate)
                }
              >
                <IconUp color={switchState} />
              </IconButton>

              <IconButton
                sx={{
                  height: '20px',
                  width: '30px',
                  borderRadius: ' 0px 0px 12px 0px;',
                  background: '#EBEEFE',
                  '&:hover': {
                    background: '#EBEEFE',
                    borderRadius: ' 0px 0px 12px 0px;',
                  },
                  '&.Mui-disabled': {
                    background: '#d3d3d3c2',
                  },
                }}
                disabled={switchState}
                onClick={() =>
                  handleChangeStartDate(startTime - 1, event.extendedProps.currentDate)
                }
              >
                <IconDown color={switchState} />
              </IconButton>
            </Box>
          </ButtonBase>
        </Box>

        <Grid
          container
          mt={isIpadLandscape || isIpadPortrait ? 10 : 3}
          justifyContent={'flex-start'}
        >
          <Checkbox
            checked={switchState}
            size="small"
            // disabled={disableDecreaseAvail}
            onChange={(e) => handleChangeStatusOfBlockDay(e, event.extendedProps.currentDate)}
          />
          <Typography
            noWrap={true}
            sx={{ ...lableStyle, marginTop: '12px' }}
          >
            Block this day
          </Typography>
        </Grid>
      </Stack>
    </Box>
  );
};

const MemoizedEditEvent = React.memo(EditEventContent);

export default MemoizedEditEvent;
